export default __webpack_public_path__ + "static/product_menu-340cd9f1d8eab678c035e477f32fea65.png";